import { css } from "@emotion/react";

export default {
  container: css`
    display: flex;
    flex-wrap: wrap;
  `,
};
